import comp from "./IconAvatar";
export default comp;
